export default __webpack_public_path__ + "static/media/origins_of_the_rivalry_1.95a41633.png";